<!--  -->

<template>
    <el-submenu :index="menu_data.id" v-if="existChild" >
        <template slot="title">
            <i v-if="menu_data.icon" :class="menu_data.icon" ></i>
            <span>{{menu_data.name}}</span>
        </template>
        <MenuItem v-for="(item) of menu_data.childList" :key="item.id" :menu_data="item" />
    </el-submenu>
    <el-menu-item :index="menu_data.id" v-else >
        <i v-if="menu_data.icon" :class="menu_data.icon" ></i>
        <span slot="title">{{menu_data.name}}</span>
    </el-menu-item>
</template>

<script>
export default {
  name: 'MenuItem',
  props: ['menu_data'],
  data () {
    return {
    }
  },

  components: {

  },

  computed: {
    existChild () {
      return this.menu_data.childList && this.menu_data.childList.length > 0
    }
  }

}

</script>

<style scoped lang='scss' >
</style>
